module.exports = __webpack_public_path__ + "static/media/garmentBag.0cff4680.svg";